// components/ProductSection1.tsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getProducts, Product } from "../pages/publicservice/productService";

const WishlistIcon: React.FC = () => (
  <svg
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.62 18.8101C11.28 18.9301 10.72 18.9301 10.38 18.8101C7.48 17.8201 1 13.6901 1 6.6901C1 3.6001 3.49 1.1001 6.56 1.1001C8.38 1.1001 9.99 1.9801 11 3.3401C12.01 1.9801 13.63 1.1001 15.44 1.1001C18.51 1.1001 21 3.6001 21 6.6901C21 13.6901 14.52 17.8201 11.62 18.8101Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const EyeIcon: React.FC = () => (
  <svg
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5799 9.99992C14.5799 11.9799 12.9799 13.5799 10.9999 13.5799C9.01992 13.5799 7.41992 11.9799 7.41992 9.99992C7.41992 8.01992 9.01992 6.41992 10.9999 6.41992C12.9799 6.41992 14.5799 8.01992 14.5799 9.99992Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.0001 18.27C14.5301 18.27 17.8201 16.19 20.1101 12.59C21.0101 11.18 21.0101 8.80997 20.1101 7.39997C17.8201 3.79997 14.5301 1.71997 11.0001 1.71997C7.47009 1.71997 4.18009 3.79997 1.89009 7.39997C0.990088 8.80997 0.990088 11.18 1.89009 12.59C4.18009 16.19 7.47009 18.27 11.0001 18.27Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const API_PATH = process.env.REACT_APP_API_PATH;

const ProductSection1: React.FC = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      setLoading(true);

      const data = await getProducts();

      setProducts(data);
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  };
  const getProductImage = (product: Product) => {
    // primary image
    const primaryImage = product.images?.find(
      (x) => x.isPrimary && x.imageURL
    );

    // first valid image
    const firstImage = product.images?.find(
      (x) => x.imageURL && x.imageURL.trim() !== ""
    );

    const imagePath =
      primaryImage?.imageURL || firstImage?.imageURL;

    // fallback image
    if (!imagePath) {
      return "/assets/img/products/product-1-1.jpg";
    }
    // full image url
    return `${API_PATH}/uploads/${imagePath}`;
  };

  if (loading) {
    return (
      <section className="section-layout1 space space-extra-bottom z-index-common">
        <div className="container text-center text-white">
          Loading products...
        </div>
      </section>
    );
  }

  return (
    <section className="section-layout1 space space-extra-bottom z-index-common">
      <img
        className="ele1"
        src="/assets/img/shapes/ele-1-1.svg"
        alt="shape"
      />
      <img
        className="ele2"
        src="/assets/img/shapes/ele-1-2.svg"
        alt="shape"
      />

      <div className="container">
        <div className="row">
          <div className="col-lg-auto mx-auto">
            <div className="title-area text-center">
              <span className="sec-subtitle">Find the perfect</span>

              <h2 className="sec-title text-white">
                High Class Jewellery
              </h2>

              <img
                src="/assets/img/shapes/title-shape-1.svg"
                alt="title shape"
              />
            </div>
          </div>
        </div>

        <div className="row gx-60">

          {products.map((product, i) => (
            <div
              key={product.productID}
              className="col-lg-3 col-md-6 wow animate__fadeInUp"
              data-wow-delay={`${0.25 + i * 0.2}s`}
            >
              <div className="product-style1">
                <div className="product-img">
                  <img
                    className="img"
                    src={getProductImage(product)}
                    alt={product.productName}
                    onError={(e) => {
                      (e.currentTarget as HTMLImageElement).src =
                        "/assets/img/products/product-1-1.jpg";
                    }}
                  />

                  <div className="product-action">
                    <button className="product-action__btn">
                      <WishlistIcon />
                    </button>

                    <button className="product-action__btn">
                      <EyeIcon />
                    </button>
                  </div>
                </div>

                <h3 className="product-title">
                  <Link to={`/shop-details/${product.productSlug}`}>
                    {product.productName}
                  </Link>
                </h3>
<span className="product-price">
  <span className="product-price__number">
    ₹{product.sellingPrice}
  </span>

  {product.mrp > product.sellingPrice && (
    <del className="ms-2 product-price__number">
      ₹{product.mrp}
    </del>
  )}

  <Link
    className="product-cart"
    to={`/cart/${product.productID}`}
  >
    add to cart
  </Link>
</span>
                <div className="product-rate">
                  {[...Array(5)].map((_, j) => (
                    <i key={j} className="fa-solid fa-star"></i>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductSection1;